export default __webpack_public_path__ + "static/media/play_4.528fbd16.jpg";